import { FC } from "react"

import { useNavigate } from "react-router-dom"

import { Table } from "@/components/_Shared/Table"
import { Resource } from "@/constants/permission"

import { FinanceReturnFundsColumns } from "./FinanceReturnFundsColumns"
import { useFinanceReturnFundsFilters } from "./FinanceReturnFundsFilters"

import { useFinanceReturnFundsQuery } from "@/hook/Finance/ReturnFunds/useFinanceReturnFundsQuery"
import { useMessage } from "@/hook/useMessage"
import { usePermission } from "@/hook/usePermission"
import { useTable } from "@/hook/useTable"

import { FINANCE_RETURN_FUNDS_KEY, IFinanceReturnFunds } from "@/types/IFinanceReturnFunds"

import { paths } from "@/router/paths"

const FinanceReturnFunds: FC = () => {

    const pageCacheKey = FINANCE_RETURN_FUNDS_KEY

    const navigate = useNavigate()

    const { filters } = useFinanceReturnFundsFilters()

    const { columns, pagination, filter, order } = useTable({
        initialColumns: FinanceReturnFundsColumns,
        key: pageCacheKey
    })

    const { data: retrunsData, isLoading: retrunsDataLoading } = useFinanceReturnFundsQuery({
        Page: pagination.page,
        PageSize: pagination.pageSize,
        Filter: filter.filter,
        OrderBy: order.orderBy
    })

    const onRowClickHandler = (data: IFinanceReturnFunds) => {
        navigate(paths.financeReturnFundsById(data.id))
    }

    return (
        <Table
            tableTitle="Возвраты средств"
            dataSource={retrunsData?.response.data}
            columns={columns.data}
            onUpdateColumns={columns.onColumnChange}
            filters={{
                filters: filters,
                onSubmit: filter.onFilterChange,
                onCancel: filter.onFilterReset,
                filterKey: pageCacheKey
            }}
            rowKey="id"
            isLoading={retrunsDataLoading}
            isSelectable={false}
            onSorterChange={order.setOrderBy}
            permission={{
                resource: Resource.FinanceReturnFunds
            }}
            pagination={{
                currentPage: pagination.page,
                pageSize: pagination.pageSize,
                total: retrunsData?.response.count,
                onPageChange: pagination.onPageChange,
                onPageSizeChange: pagination.onPageSizeChange
            }}
            onRowClick={onRowClickHandler}
        />
    )
}
export default FinanceReturnFunds